import * as React from 'react';

const SVGContact: React.SFC<SvgProps> = props => (
  <svg width={20} height={17} {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M6.902.74h6.063c3.23 0 5.895 2.603 5.827 5.72a5.59 5.59 0 0 1-4.475 5.357c-.574.119-.69.449-.687 1.076v2.718c0 .186-.121.347-.278.382a.37.37 0 0 1-.403-.169l-1.944-3.313A1.163 1.163 0 0 0 10 11.937H7.03c-3.136 0-5.738-2.42-5.822-5.442C1.12 3.34 3.695.74 6.902.74z"
        stroke="#B0BDC0"
      />
      <ellipse
        stroke="#FFF"
        strokeWidth={2.549}
        cx={4.167}
        cy={11.422}
        rx={2.79}
        ry={2.922}
      />
      <ellipse
        stroke="#B0BDC0"
        fill="#FFF"
        fillRule="nonzero"
        cx={4.167}
        cy={11.422}
        rx={2.79}
        ry={2.922}
      />
    </g>
  </svg>
);

export default SVGContact;
